var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#54708C",
    d: "M19 20c.552 0 1 .448 1 1s-.448 1-1 1H5c-.552 0-1-.448-1-1s.448-1 1-1h14zM12.62 4.215l.087.078 4.243 4.243c.39.39.39 1.023 0 1.414-.39.39-1.024.39-1.414 0L13 7.415 13 18c0 .552-.448 1-1 1s-1-.448-1-1V7.415L8.465 9.95c-.39.39-1.023.39-1.414 0-.39-.39-.39-1.024 0-1.414l4.243-4.243c.363-.363.934-.389 1.327-.078z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/pickup.dbe97732ae1d618ca874515418a7d7d2.svg";
export { ForwardRef as ReactComponent };